import React from 'react';
import { Card, Empty } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { Chart } from 'react-google-charts';
import { Button } from '../../../design-system';

const COLORS = ['#1B1B1B', '#FED230'];

const AgeDistributionChart = ({ data = [], onSegmentClick, onExportCSV }) => {
    if (!data || data.length === 0) {
        return (
            <Card title="Age Distribution" className="chart-card">
                <Empty description="No data available" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </Card>
        );
    }

    const chartData = [['Age Group', 'Male', 'Female']];
    for (const item of data) {
        chartData.push([item.ageGroup, item.male, item.female]);
    }

    const options = {
        isStacked: true,
        legend: {
            position: 'top',
            alignment: 'center',
            textStyle: { fontSize: 12 },
        },
        hAxis: {
            title: 'Age Group',
        },
        vAxis: {
            title: 'Employees',
            minValue: 0,
            format: '0',
        },
        colors: COLORS,
        chartArea: { width: '80%', height: '70%' },
        backgroundColor: 'transparent',
        bar: { groupWidth: '70%' },
    };

    const chartEvents = onSegmentClick ? [
        {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
                const selection = chartWrapper.getChart().getSelection();
                if (selection.length > 0) {
                    const row = selection[0].row;
                    const item = data[row];
                    if (item) onSegmentClick(item);
                }
            },
        },
    ] : [];

    return (
        <Card
            title="Age Distribution"
            className="chart-card"
            extra={
                onExportCSV && (
                    <Button
                        size="small"
                        variant="secondary"
                        icon={<DownloadOutlined />}
                        onClick={() => onExportCSV('age', data)}
                        title="Download CSV"
                    />
                )
            }
        >
            <Chart
                chartType="ColumnChart"
                data={chartData}
                options={options}
                width="100%"
                height="300px"
                chartEvents={chartEvents}
            />
        </Card>
    );
};

export default AgeDistributionChart;
